'use es6';

import { createSelector } from 'reselect';
import { getUserId } from './auth';

const getReviewsState = state => state.profile.reviews;

export const getReviewsRequestState = createSelector([getReviewsState], state => state.listRequestState);
export const getReviews = createSelector([getReviewsState], state => state.list);
export const getReviewTotal = createSelector([getReviewsState], state => state.total);
export const getReviewStatsRequestState = createSelector([getReviewsState], state => state.statsRequestState);
export const getReviewStats = createSelector([getReviewsState], state => state.stats);
export const getReviewFilters = createSelector([getReviewsState], state => state.filters);
export const getReviewSubmitRequestState = createSelector([getReviewsState], state => state.reviewSubmitRequestState); // Selector factory enables us to pass props into useSelector and maintain memoization

export const makeGetUserMarkedHelpfulSelector = () => createSelector([getReviews, getUserId, (_, reviewId) => reviewId], (reviews, userId, reviewId) => {
  const review = reviews.find(rev => rev.get('id') === reviewId);
  return review && review.get('attributes').some(attr => attr.get('userId') === userId && attr.get('helpful'));
});